
import VButton from '@/components/ui/VButton';
import { mapState } from "vuex";

export default {
    name: 'FaqBanner',
    components: {
        VButton
    },
    computed: {
        ...mapState('profile', ['isAuthorized']),

    },
    methods: {
        handleClick() {
            this.isAuthorized ? this.$router.push({ name: 'profile-support-create' }) :this.$router.push({ name: 'contacts' });
        }
    }
}
